export enum BiointelligentLinkType {
  NUCLEOTIDE_PART = 'NUCLEOTIDE_PART',
  AMINO_ACID_PART = 'AMINO_ACID_PART',
  TRANSCRIPTION = 'TRANSCRIPTION',
  TRANSLATION = 'TRANSLATION',
}
